import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { propTypes } from '../../util/types';
import { resolveLatestProcessName, getProcess } from '../../transactions/transaction';

import css from './OrderBreakdown.module.css';


const LineItemTotalPrice = props => {
  const { transaction, isProvider, intl } = props;
  const processName = resolveLatestProcessName(transaction?.attributes?.processName);
  if (!processName) {
    return null;
  }
  const process = getProcess(processName);
  const isCompleted = process.isCompleted(transaction?.attributes?.lastTransition);
  // Every way an order closes with the money given back (a seller's cancel,
  // an accepted cancel request, a ship-by cancel, a dispute) ends in these.
  const isRefunded =
    process.isRefunded(transaction?.attributes?.lastTransition) ||
    ['state/canceled', 'state/refunded'].includes(transaction?.attributes?.state);

  let providerTotalMessageId = 'OrderBreakdown.providerTotalDefault';
  if (isCompleted) {
    providerTotalMessageId = 'OrderBreakdown.providerTotalReceived';
  } else if (isRefunded) {
    providerTotalMessageId = 'OrderBreakdown.providerTotalRefunded';
  }

  // Once something was refunded the buyer's total is what they have paid,
  // net of it, not the order's price.
  const hasRefund = (transaction?.attributes?.lineItems || []).some(
    line => !line.reversal && /^line-item\/(refund-|goodwill-refund|chargeback$)/.test(line.code)
  );
  const totalLabel = isProvider ? (
    <FormattedMessage id={providerTotalMessageId} />
  ) : (
    <FormattedMessage id={hasRefund ? 'OrderBreakdown.totalPaid' : 'OrderBreakdown.total'} />
  );

  // The order's line items are its money: what the buyer has paid net of
  // refunds, and what the seller earns from it, as Sharetribe adds them up.
  const totalPrice = isProvider ? transaction.attributes.payoutTotal : transaction.attributes.payinTotal;
  const formattedTotalPrice = formatMoney(intl, totalPrice);

  return (
    <>
      <hr className={css.totalDivider} />
      <div className={css.lineItemTotal}>
        <div className={css.totalLabel}>{totalLabel}</div>
        <div className={css.totalPrice}>{formattedTotalPrice}</div>
      </div>
    </>
  );
};

LineItemTotalPrice.propTypes = {
  transaction: propTypes.transaction.isRequired,
  isProvider: bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemTotalPrice;
